"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgSkipBack = function SvgSkipBack(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M32 16.002v16a1 1 0 01-1.625.78l-10-8a1 1 0 010-1.561l10-8a1 1 0 011.625.78zM17 16a1 1 0 011 1v14a1 1 0 01-2 0V17a1 1 0 011-1zm13 2.083l-7.4 5.919 7.4 5.92v-11.84z",
    id: "skip-back_svg__a"
  }));
};

var _default = SvgSkipBack;
exports["default"] = _default;